import React, { useEffect } from "react";
import { LEVEL_ADMIN } from "../../../utils/userPermissions";
import { usePermissions } from "../../../context/permissionsContext";

function Accounts({ users, payoutsPaused = false, setPayoutsPaused }) {
  const { hasPermission } = usePermissions();

  const stats = [
    {
      label: "Earnings",
      value: `$${users?.stats?.total_earning ?? "0.00"}`,
      color: "#2DCD88",
    },
    {
      label: "Withdrawals",
      value: `$${users?.stats?.total_withdrawal ?? "0.00"}`,
      color: "#FA6340",
    },
    {
      label: "Balance",
      value: `$${users?.stats?.total_balance ?? "0.00"}`,
      color: "#C60707",
    },
    {
      label: "In Process",
      value: `$${users?.stats?.total_in_process ?? "0.00"}`,
      color: "#FFB703",
    },
  ];

  const adminStats = [
    {
      label: "Total Payouts",
      value: `$${users?.stats?.total_earning ?? "0.00"}`,
      color: "#2DCD88",
    },
    {
      label: "Withdrawals",
      value: `$${users?.stats?.total_withdrawal ?? "0.00"}`,
      color: "#FA6340",
    },
    {
      label: "Balance",
      value: `$${users?.stats?.total_balance ?? "0.00"}`,
      color: "#C60707",
    },
    {
      label: "In Process",
      value: `$${users?.stats?.total_in_process ?? "0.00"}`,
      color: "#FFB703",
    },
  ];

  const selectedStats = hasPermission(LEVEL_ADMIN) ? adminStats : stats;

  useEffect(() => {
    setPayoutsPaused(payoutsPaused);
  }, [payoutsPaused]);

  return (
    <div className="col-lg-9 col-12 px-0 pr-lg-4 pr-0">
      <div className="card mb-0" style={{ backgroundColor: "#ffffff9e" }}>
        <div className="card-body pt-3 pb-3">
          <div className="row pt-2">
            {selectedStats.map((stat, index) => (
              <div
                key={index}
                className={`col-md-3 col-6 mt-md-0 mt-5 stats-item pl-4 ${
                  index !== 0 ? "border-left" : ""
                }`}
              >
                <div className="pl-1">
                  <p className="stat-value mb-0 text-nowrap">{stat.value}</p>
                  <p className="stat-label" style={{ color: stat.color }}>
                    {stat.label}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className="col-md-12 col-6 d-center text-nowrap"
        style={{
          marginTop: "32px",
        }}
      >
        {!hasPermission(LEVEL_ADMIN) && (
          <span className="bg-default text-white px-2 py-2 rounded-top d-lg-block d-none">
            Payouts will be available for withdrawal after 30 days of referral
            sign up.
          </span>
        )}

        {/* {hasPermission(LEVEL_ADMIN) ? (
          <div className="d-space-between w-100">
            <div>
              <span className="mr-2">Pause Payouts</span>
              <label className="switch mb-0">
                <input
                  type="checkbox"
                  checked={!payoutsPaused}
                  onChange={handleTogglePayouts}
                />
                <span className="sliderr round"></span>
              </label>
              <span className="ml-2">Resume Payouts</span>
            </div>
            <button
              className="btn btn-default px-5 py-2"
              onClick={() => navigate("/admin/w9-form-requests")}
            >
              User Requests
            </button>
          </div>
        ) : (
          <>
            <Link to="/affiliate-program/my-earnings">
              <button className="btn btn-default py-2 px-4 mr-2">
                Initiate Withdraw
              </button>
            </Link>
            <Link to="/affiliate-program/income-history">
              <button className="btn btn-primary py-2 px-4">
                Income History
              </button>
            </Link>
          </>
        )} */}
      </div>
    </div>
  );
}

export default Accounts;
